import type { IconComponent } from "@overmap-ai/blocks"
import { ProcedureStepEventType, ProcedureStepFieldValuesReviewType } from "@overmap-ai/common"
import { amber, gray, green, red } from "@radix-ui/colors"
import { Check, Circle, Eye, RefreshCcw, X } from "lucide-react"

import { ProcedureStepCompletionStatus } from "../enums/procedures"
import { modelIconMapping } from "./icons"

export const procedureStepCompletionStatusData: Record<
	ProcedureStepCompletionStatus,
	{ label: string; color: string; accentColor: string; icon: IconComponent }
> = {
	[ProcedureStepCompletionStatus.COMPLETE]: {
		accentColor: "success",
		color: green.green9,
		label: "Completed",
		icon: Check,
	},
	[ProcedureStepCompletionStatus.FAILED]: { accentColor: "danger", color: red.red9, label: "Failed", icon: X },
	[ProcedureStepCompletionStatus.INCOMPLETE]: {
		accentColor: "base",
		color: "var(--base-a4)",
		label: "Incomplete",
		icon: Circle,
	},
}

export const procedureStepFieldValuesReviewTypeData: Record<
	ProcedureStepFieldValuesReviewType,
	{
		icon: IconComponent
		color: string
		accentColor: string
		actionLabel: string
		statusLabel: string
		label: string
		description: string
	}
> = {
	[ProcedureStepFieldValuesReviewType.CHANGES_REQUESTED]: {
		icon: RefreshCcw,
		color: amber.amber9,
		accentColor: "warning",
		actionLabel: "requested changes",
		statusLabel: "Changes requested",
		label: "Request changes",
		description: "Submit feedback and suggest changes.",
	},
	[ProcedureStepFieldValuesReviewType.REJECTED]: {
		icon: X,
		color: red.red9,
		accentColor: "danger",
		actionLabel: "rejected",
		statusLabel: "Rejected",
		label: "Reject",
		description: "Submit feedback and reject.",
	},
	[ProcedureStepFieldValuesReviewType.APPROVED]: {
		icon: Check,
		color: green.green9,
		accentColor: "success",
		actionLabel: "approved",
		statusLabel: "Approved",
		label: "Approve",
		description: "Submit feedback and approve.",
	},
}

export const procedureStepEventTypeData: Record<
	ProcedureStepEventType,
	{
		icon: IconComponent
		color: string
		actionLabel: string
		accentColor: string
	}
> = {
	[ProcedureStepEventType.ADD_ASSIGNEE]: {
		icon: modelIconMapping.assignee,
		color: gray.gray9,
		actionLabel: "added assignee",
		accentColor: "base",
	},
	[ProcedureStepEventType.REMOVE_ASSIGNEE]: {
		icon: modelIconMapping.assignee,
		color: gray.gray9,
		actionLabel: "removed assignee",
		accentColor: "base",
	},
	[ProcedureStepEventType.ADD_REVIEWER]: {
		icon: Eye,
		color: gray.gray9,
		actionLabel: "added reviewer",
		accentColor: "base",
	},
	[ProcedureStepEventType.REMOVE_REVIEWER]: {
		icon: Eye,
		color: gray.gray9,
		actionLabel: "removed reviewer",
		accentColor: "base",
	},
}
